/**
 * AP-10 — FM-WIN-13: About.
 *
 * Reiner Textblock, Wortlaut 1:1 aus InfoWindow.cpp:117-130. Einmal erzeugt,
 * danach nur noch ein-/ausgeblendet — wie das Original, das sein `InfoWindow`
 * bei `WM_CLOSE` nur versteckt.
 */

import './viewsD.css';
import { createFloatingPanel } from './filters/FloatingPanel';

const HEADING = 'CAN Monitor';

const BODY = `Name:            CAN Monitor
Version:         0.0.0.1
Author:          Patrick Paas
Department:      System Support & Consulting ecomat mobile
Company:         ifm ecomatic gmbh

Description:
Native Windows 11 CAN bus monitor and decoder. Supports CANopen
(EMCY/SDO/PDO), ISOBUS/J1939 (PGN, DM1), and DBC-based signal
decoding, with PEAK/CANable/Sontheim adapter support, message
trace recording/playback and a TX message list.

License information:
This software is provided free of charge and "as is", without
warranty of any kind, express or implied. Use is at your own
risk; the author accepts no liability for any damage or data
loss arising from its use. All rights reserved.`;

export interface AboutHandle {
  show(): void;
  hide(): void;
}

let instance: AboutHandle | null = null;

function createAboutWindow(): AboutHandle {
  const panel = createFloatingPanel('About');
  panel.element.classList.add('cm-panel-window--medium');

  const heading = document.createElement('div');
  heading.className = 'cm-about__heading';
  heading.textContent = HEADING;

  const body = document.createElement('pre');
  body.className = 'cm-about__body';
  body.textContent = BODY;

  panel.body.append(heading, body);
  return { show: () => panel.show(), hide: () => panel.hide() };
}

/** `Help ⯆ > About` — erzeugt das Fenster beim ersten Aufruf. */
export function showAboutWindow(): void {
  instance ??= createAboutWindow();
  instance.show();
}
